module.exports = __webpack_public_path__ + "images/3026efb6afd4026d6af9e2a6561f9ad8.png";